import Tabswitch from "../../../../../layout/components/Tabswitch/Tabswitch";

function Header() {
  let tabData = [
    {
      tabName: "List",
      tabLink: "/admin/settings/list",
    },
    {
      tabName: "Summary",
      tabLink: "/admin/settings/summary",
    },
  ];

  return (
    <>
      <Tabswitch tabData={tabData} />
    </>
  );
}

export default Header;
